import { httpClient } from 'api';
import { TimelineEventItem, TimelineEventListPaginated, TimelineParticipationItem } from 'types/Timeline';

export const timelineApi = {
	getTimelineEventsPaged: (applicationId: number, eventId?: number | null, page = 0) =>
		httpClient.get<TimelineEventListPaginated>(`timeline/application/${applicationId}/list`, { eventId, page }),
	getTimelineEventsSimple: (applicationId: number) =>
		httpClient.get<TimelineEventItem[]>(`timeline/application/${applicationId}/list-simple`),
	sendReminderNotification: (applicationId: number, eventId: number) =>
		httpClient.post<boolean>(`timeline/application/${applicationId}/event/${eventId}/remind`),
	confirmParticipation: (applicationId: number, eventId: number) =>
		httpClient.post<TimelineEventItem>(`timeline/application/${applicationId}/event/${eventId}/participation`),
	cancelParticlipation: (applicationId: number, eventId: number) =>
		httpClient.delete<TimelineEventItem>(`timeline/application/${applicationId}/event/${eventId}/participation`),
	registerVisit: (applicationId: number, eventId: number) =>
		httpClient.post<TimelineEventItem>(`timeline/application/${applicationId}/event/${eventId}/visit`),

	// program
	program: {
		getTimelineEventsPaged: (programId: number, page = 0) =>
			httpClient.get<TimelineEventListPaginated>(`timeline/program/${programId}/paginated`, {
				page,
			}),
		getTimelineEvents: (programId: number) =>
			httpClient.get<TimelineEventItem[]>(`timeline/program/${programId}/list`),
		getTimelineEventForEdit: (programId: number, eventId: number) =>
			httpClient.get<TimelineEventItem>(`timeline/program/${programId}/event/${eventId}`),
		addTimelineEvent: (programId: number, data: any) =>
			httpClient.post<TimelineEventItem>(`timeline/program/${programId}/event`, data),
		editTimelineEvent: (programId: number, eventId: number, data: any) =>
			httpClient.put<TimelineEventItem>(`timeline/program/${programId}/event/${eventId}`, data),
		removeTImelineEvent: (programId: number, eventId: number) =>
			httpClient.delete<boolean>(`timeline/program/${programId}/event/${eventId}`),
		getTimelineEventsParticipations: (programId: number, eventId: number) =>
			httpClient.get<TimelineParticipationItem[]>(`timeline/program/${programId}/event/${eventId}/participation`),
		uploadImage: (programId: number, data: FormData) =>
			httpClient.put<string>(`timeline/program/${programId}/upload-image`, data),
	},
};
